import { safeEval } from './parser';

function resolveLazy(value: any, ctx: any): any {
    if (Array.isArray(value)) {
        return value.map((item) => resolveLazy(item, ctx));
    }

    if (
        value &&
        typeof value === "object" &&
        value.__expr
    ) {
        return safeEval(
            value.__expr,
            ctx
        );
    }

    if (
        value &&
        typeof value === "object" &&
        value.constructor === Object
    ) {
        return Object.fromEntries(
            Object.entries(value).map(([key, item]) => [
                key,
                resolveLazy(item, ctx),
            ])
        );
    }

    return value;
}

export default function resolveProps(node: any, ctx: any) {
    const props = resolveLazy({ ...node.props }, ctx);

    if (typeof props.initialValues === "string") {
        props.initialValues = ctx?.values?.[props.initialValues];
    }

    // 🎯 bind handler string → function
    if (typeof props.onSubmit === "string") {
        props.onSubmit = ctx?.handlers?.[props.onSubmit];
    }

    // 🎯 bind schema
    if (typeof props.validationSchema === "string") {
        props.validationSchema = ctx?.schemas?.[props.validationSchema];
    }
    if (
        node.type === "table" &&
        typeof props.datasource === "string"
    ) {
        props.datasource =
            ctx?.datasources?.[props.datasource ] || [];
    }

    if (
        ["select", "radio_group", "checkbox_group", "box_group", "box_radio_group", "box_checkbox_group"].includes(node.type) &&
        typeof props.options === "string"
    ) {
        props.options =
            ctx?.options?.[props.options] ??
            ctx?.[props.options] ??
            [];
    }

    // 🎯 bind form config theo name
    if (node.type === "form" && props.name) {

        const formConfig = ctx?.forms?.[props.name];

        if (formConfig) {
            return {
                ...formConfig,
                ...props, // DSL override
            };
        }
    }

    return props;
}
